// constants.js

export const DEFAULT_API_KEY = "";
export const DEFAULT_MAP_ID = "e6ead35a6ace8599";
